export const environment = {
  production: false,
  apiBaseUrl: 'https://stage-api-mockingbird.apps.stargate.is/api/v1',
};
